module.exports = __webpack_public_path__ + "assets/img/help_top_image.0442d66b.svg";